import { memo, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { Button, FormField, HStack, VStack } from '@library';
import type { SubmitBlockComponent } from '../../../types/customStoryblokComponents';
import { useStoryblokContext } from '../../StoryblokFormContext';

interface SubmitBlockProps {
    params: SubmitBlockComponent;
}

const SubmitBlock = ({ params: { label } }: SubmitBlockProps) => {
    const { formState, watch } = useFormContext();
    const { isValidating, isSubmitting, isLoading } = formState;
    const { readonly } = useStoryblokContext();
    const confirmed = watch('confirmation');

    const isDisabled = useMemo(() => {
        return (
            isValidating || isSubmitting || isLoading || readonly || !confirmed
        );
    }, [isValidating, isSubmitting, isLoading, readonly, confirmed]);

    if (readonly) {
        return null;
    }

    return (
        <VStack gap="small">
            <FormField label={label}>
                <HStack gap="small">
                    <Button type="submit" disabled={isDisabled}>
                        <FormattedMessage id="submit" />
                    </Button>
                    <Button type="reset" outline>
                        <FormattedMessage id="cancel" />
                    </Button>
                </HStack>
            </FormField>
        </VStack>
    );
};

export default memo(SubmitBlock);
